import React from "react";


interface EmptyQuestionsAlertProps {
  onCancel: () => void;
}

const EmptyQuestionsAlert: React.FC<EmptyQuestionsAlertProps> = ({ onCancel }) => {

  return (
    <div className="w-full max-w-md p-6 text-white ">
      <div className="text-lg font-bold ">Ошибка</div>
      <div className="text-left  py-3 text-base font-normal w-full">У вас не осталось нерешенных вопросов. Отгадайте Счастливую карту, чтобы задавать больше вопросов! </div>
      <div className="flex justify-end pt-4">
        <button className={`text-left px-6 py-3 text-base font-normal pt-2 pb-2  text-center `} onClick={onCancel}>Ок</button>
      </div>
    </div>
  );
};

export default EmptyQuestionsAlert; 